module.exports = __webpack_public_path__ + "img/solution28803.0dc67641.png";